import React from 'react';
import { useTheme } from '../ThemeContext';

/**
 * A homeowner setup step (questions, address, inventory list, password).
 * The Capacitor shell turns off WKWebView scrolling and locks html, body,
 * #root, and the legal page frame. Only .app-scroll can move. This element
 * is that scroller. Safe-area padding is inside it, so the first line clears
 * the status bar and the last button clears the home indicator.
 * Safari scrolls the document. The box grows with the page and is not a
 * fixed 100vh frame.
 */
export default function SetupScreen({ children, centered = false, style }) {
  const { colors } = useTheme();
  const className = centered
    ? 'app-scroll app-scroll-center setup-screen'
    : 'app-scroll setup-screen';
  return (
    <div
      className={className}
      style={Object.assign({
        background: colors.background,
        color: colors.text,
      }, centered ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      } : null, style)}
    >
      {children}
    </div>
  );
}
